import { Tooltip } from 'antd'
import { FC, memo, useEffect, useRef, useState } from 'react'
import { useWindowSize } from 'react-use'
import styled from 'styled-components'

const TicketGateRowTitleContainer = styled.span`
  width: 30%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const RawTruncatedTitle: FC<{ title: string }> = ({ title }) => {
  const titleRef = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)
  const { width } = useWindowSize()

  useEffect(() => {
    const element = titleRef.current
    if (element) {
      setIsTruncated(element.scrollWidth > element.clientWidth)
    }
  }, [title, width])

  const titleElement = (
    <TicketGateRowTitleContainer ref={titleRef}>
      {title}
    </TicketGateRowTitleContainer>
  )

  if (isTruncated) {
    return <Tooltip title={title}>{titleElement}</Tooltip>
  }

  return titleElement
}

export const TruncatedTitle = memo(RawTruncatedTitle)
